import { UrlSegment } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { IAuthState, IAuthUser } from './auth.service.interface';

/**
 * 
 */
export class AuthBaseService {

  /**
   *
   */
  constructor() { }

  protected _authState: BehaviorSubject<IAuthState>;


  /**
   * 
   * @param code 
   * @param email 
   * @param displayName
   */
  protected signInImpl(code: string, email: string, displayName: string) {
    const user: IAuthUser = {
      code: code,
      title: displayName,
      email: email
    }

    const authState: IAuthState = {
      isLoggedIn: true,
      navLinks: this.buildNav(user),
      userInfo: {
        ...user
      }
    };
    this.stateSave(authState);
    this._authState.next(authState);
  }



  /**
   * 
   */
  protected signOutImpl() {
    const authState: IAuthState = { isLoggedIn: false, navLinks: [] };
    this.stateSave(authState);
    this._authState.next(authState);
  }

  /**
    * 
    * @returns 
    */
  currentState(): IAuthState {
    return this._authState.value;
  }

  /**
   * 
   * @param url 
   * @returns 
   */
  canAccessRoute(url: UrlSegment[]): boolean {
    return this.currentState().isLoggedIn;
  }

  /**
   *
   */
  watchState$(): BehaviorSubject<IAuthState> {
    return this._authState;
  }

  /**
   * 
   * @param authState 
   */
  protected stateSave(authState: IAuthState) {
    localStorage.setItem('auth-state', JSON.stringify(authState));
  }

  /**
   * 
   * @returns 
   */
  protected stateLoad(): IAuthState {
    const current = localStorage.getItem('auth-state');
    const ret: IAuthState = current ? JSON.parse(current) : undefined;
    return ret;
  }

  /**
   *
   * @param user
   */
  protected buildNav(user: IAuthUser): any[] {

    const appSections: any[] = [
      {
        name: 'Tools',
        hidden: false,
        pages: [
          { routerLink: '/', name: 'Wealth Calculator' }
        ]
      },
      {
        name: 'Site Links',
        hidden: false,
        pages: [
          { name: 'Contact', url: 'https://renttoretirement.com/contact/' },
          { name: 'Privacy Policy', url: 'https://renttoretirement.com/rent-to-retirement-privacy-policy/' }
        ]
      }
    ];

    // return array
    const ret: any[] = [
      ...appSections
    ].filter(nsd => !nsd.hidden);
    return ret;
  }

}
